import React, { useLayoutEffect, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Header, { HeaderLeft, HeaderRight } from '../../../layout/Header/Header';
import Popovers from '../../../components/bootstrap/Popovers';
import Button, { IButtonProps } from '../../../components/bootstrap/Button';
import useDarkMode from '../../../hooks/useDarkMode';
import LANG, { getLangWithKey, ILang } from '../../../lang';
import showNotification from '../../../components/extras/showNotification';
import Icon from '../../../components/icon/Icon';
import { useNavigate } from 'react-router-dom';
import { centralApi, userApi } from '../../AxiosInstance/CreateInstance';

const DashboardHeader = () => {
	const { darkModeStatus, setDarkModeStatus } = useDarkMode();
	const navigate = useNavigate();
	const styledBtn: IButtonProps = {
		color: darkModeStatus ? 'dark' : 'light',
		hoverShadow: 'default',
		isLight: !darkModeStatus,
		size: 'lg',
	};

	const { i18n } = useTranslation();

	const changeLanguage = (lng: ILang['key']['lng']) => {
		i18n.changeLanguage(lng).then(() =>
			showNotification(
				<span className='d-flex align-items-center'>
					<Icon icon={getLangWithKey(lng)?.icon} size='lg' className='me-1' />
					<span>{`Language changed to ${getLangWithKey(lng)?.text}`}</span>
				</span>,
				'You updated the language of the site. (Only "Aside" was prepared as an example.)',
			),
		);
	};

	/**
	 * Language attribute
	 */
	useLayoutEffect(() => {
		document.documentElement.setAttribute('lang', i18n.language);
	});

	useEffect(() => {
		const fetchUserProfile = async () => {
			try {
				const response = await centralApi.get(`userService/user/profile`, {});

			} catch (err: any) {
				const errorMsg = err.response?.data?.msg || 'Unauthorized or error fetching data';
			}
		};

		fetchUserProfile();
	}, []);

	return (
		<Header>
			<div className='w-100 d-flex justify-content-start '>
				Dashboard
			</div>
		</Header>
	);
};

export default DashboardHeader;
